import { ActionState, TileHexType, TurnState } from '@colonist/game-states';
export class UIGameInitialPlacementsConfirmationController {
    highlightNeighborTilesAndPorts(index) {
        if (!this.isPlacingSettlementOrCity()) return;
        const corner = this.uiGameManager.gameState.mapState.tileState.tileCorners[index];
        const neighborHexFaces = corner.hexCorner.touchingFaces();
        for (const hexFace of neighborHexFaces){
            var _this_uiGameManager_gameState_mapState_tileState_getTileHex;
            const tileType = (_this_uiGameManager_gameState_mapState_tileState_getTileHex = this.uiGameManager.gameState.mapState.tileState.getTileHex(hexFace)) === null || _this_uiGameManager_gameState_mapState_tileState_getTileHex === void 0 ? void 0 : _this_uiGameManager_gameState_mapState_tileState_getTileHex.tileType;
            const notAllowedTileHexType = [
                TileHexType.Desert,
                TileHexType.Sea,
                TileHexType.Fog
            ];
            if (tileType == undefined) continue;
            if (notAllowedTileHexType.includes(tileType)) continue;
            const tileView = this.uiGameManager.mapController.getTileViewForHexFace(hexFace);
            tileView === null || tileView === void 0 ? void 0 : tileView.highlightWithWhiteSurrounding();
        }
        this.uiGameManager.mapController.portController.highlightPort(corner.hexCorner);
    }
    removeNeighborTilesAndPortsHighlights() {
        const tiles = this.uiGameManager.gameState.mapState.tileState.tiles;
        tiles.forEach((tile)=>{
            var _this_uiGameManager_mapController_getTileViewForHexFace;
            return (_this_uiGameManager_mapController_getTileViewForHexFace = this.uiGameManager.mapController.getTileViewForHexFace(tile.hexFace)) === null || _this_uiGameManager_mapController_getTileViewForHexFace === void 0 ? void 0 : _this_uiGameManager_mapController_getTileViewForHexFace.resetHighlightWithWhiteSurrounding();
        });
        this.uiGameManager.mapController.portController.removePortHighlight();
    }
    isPlacingSettlementOrCity() {
        if (this.uiGameManager.gameController.currentState.turnState != TurnState.InitialPlacement) return false;
        const validAction = this.uiGameManager.gameController.currentState.actionState == ActionState.InitialPlacementPlaceSettlement || this.uiGameManager.gameController.currentState.actionState == ActionState.InitialPlacementPlaceCity;
        if (!validAction) return false;
        return true;
    }
    constructor(uiGameManager){
        this.uiGameManager = uiGameManager;
    }
}
